var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('filtersMaster',{ref:"filtersMaster",attrs:{"select":_vm.select,"filtersdef":_vm.filtros,"options":_vm.options},on:{"filter":_vm.filter,"loadSelectsData":_vm.loadSelectsData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431d666a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operativos/substatus/Filters.vue
// module id = null
// module chunks = 